import { useEffect, useState } from "react";
import Select from "react-select";
import { ChartContainer } from "../../components/Chart";
import { filtersDefaultChart, filtersDefaultChartAmount } from "../../utils/constant";
import { useDialog } from "../../contexts/DialogContext";
import { requestAuth } from "../../components/services/RequestService";
import { Circle } from "../../components/Animation";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import SimplePie from "../../components/Chart/SimplePie";
import { TableManagement } from "../../containers/Systems/TableManagement";

const Management = () => {
  return (
    <div>
      <ManagementContainer />
      {/* <ManagementContainer /> */}
    </div>
  );
};

const ManagementContainer = () => {
  const [year, setYear] = useState("2026");
  const [chartType, setChartType] = useState("Clientes");
  const { openDialog } = useDialog();
  const navigate = useNavigate()
  const location = useLocation()

  const graficas = [
    { value: "Clientes", label: "Clientes" },
    { value: "Encargados", label: "Encargados" },
    // { value: "ProcEncargados", label: "Trámites por encargados" },
    { value: "Liquidadores", label: "Liquidadores" },
    { value: "Gestores", label: "Gestores" },
    // { value: "Intermediarios", label: "Intermediarios" },
    // { value: "Comisiones", label: "Comisiones" },
    // { value: "GastosOpe", label: "Gastos de operaciones" },
    // { value: "Problemas Del Despacho", label: "Problemas Del Despacho" },
    // { value: "Observaciones Aforo", label: "Observaciones Aforo" },
    { value: "Canales", label: "Canales" },
    { value: "Mercadería", label: "Mercadería" },
    // { value: "OrigenDelEmbarque", label: "Origen Del Embarque" },
    { value: "Aduanas De Despachos", label: "Aduanas De Despachos" },
    // { value: "Examen Previo", label: "Examen Previo" },
    // { value: "Multas", label: "Multas" },
    // { value: "Reintegros", label: "Reintegros" },
    // { value: "Multa Fiscalización", label: "Multa Fiscalización" },
    // { value: "Reintegro Fiscalización", label: "Reintegro Fiscalización" },
    // {
    //   value: "Gestoria Lista De Observaciones",
    //   label: "Gestoria Lista De Observaciones",
    // },
    // {
    //   value: "Contabilidad Lista De Observaciones",
    //   label: "Contabilidad Lista De Observaciones",
    // },
  ];
  const gestiones = [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
    { value: "2022", label: "2022" },
    { value: "2021", label: "2021" },
    { value: "2020", label: "2020" },
    { value: "2019", label: "2019" },
  ];

  const handleChartTypeChange = (selectedOption) => {
    setChartType(selectedOption.value);
  };

  const handleYearChange = (selectedOption) => {
    setYear(selectedOption.value);
  };

  const ContentData = ({ actualData, selectedData }) => {
    console.log(actualData)
    let urlApi = `${actualData.urlApiMain}&value=${actualData.fieldValue}&company=${selectedData.companyId}&month=${actualData.numMonth}&fieldname=${actualData.fieldname}`

    const [data, setData] = useState(null)
    const [load, setLoad] = useState(false)
    useEffect(() => {
      setLoad(true)
      requestAuth('GET', urlApi)
        .then(function (response) {
          setData(response.data)
          setLoad(false)
        })
        .catch(function (error) {
          console.log("error")
          setLoad(false)
        })
    }, [urlApi])

    const nav = (i) => {
      console.log(location.pathname)
      if (location.pathname.includes('/rol/6/')) {
        navigate(`./step/${i.step}`)
      }
      else {
        navigate(`/rol/6/menu/ManageProcedures`)
        const timeoutId = setTimeout(() => {
          navigate(`/rol/6/procedure-type/1/step/${i.step}`)
          return () => clearTimeout(timeoutId);
        }, 2500);
      }
      // dialogClose()
    }
    return (
      load ?
        <Circle spinnerColor='text-orange-400' />
        :
        // <div className="col-span-3">
        <TableManagement
          header={[
            {
              name: "codigoDeInterno",
              label: "Código de interno",
            },
            {
              name: "stepName",
              label: "Nombre de paso",
            },
            {
              name: "edit",
              type: "action",
              label: "Acciones",
              actions: [
                {
                  label: "Añadir campo",
                  icon: "fas fa-share",
                  action: nav,
                  color: "text-[#1d4ed8]",
                },
              ],
            },
          ]}
          data={data}
          labelGrafic="trámite"
        />
      // </div>
    )
  }

  function handleClickMonth(label, data, urlApi, params, generalData, urlApiMain) {
    openDialog(
      <div style={{ width: "80vw", marginBottom: '20px' }}>
        <ChartContainer
          // title={label}
          title={`${label} - Mes: ${data?.label}`}
          type="SubChart"
          urlApi={`${urlApi}Month`}
          generalData={{ ...generalData, fieldValue: label, numMonth: data?.id, onClick: console.log(generalData) }}
          addParams={{
            dateQuery: "fechaDeFacturación",
            month: data?.id,
            value: label,
            ...params,
          }}
          ContentData={ContentData}
          actualData={{ ...generalData, fieldValue: label, numMonth: data?.id, urlApiMain: urlApiMain.replace(urlApi, `${urlApi}Table`).replace('Table ?', 'Table?') }}
        />
      </div>
    );
  }
  function handleClickCompanyMonth(label, data, urlApi, params, generalData, urlApiMain) {
    openDialog(
      <div style={{ width: "80vw", marginBottom: '20px' }}>
        <ChartContainer
          // title={label}
          title={`${label} - Mes: ${data?.label}`}
          type="SubChart"
          urlApi={`${urlApi}Company`}
          generalData={{ ...generalData, fieldValue: label, numMonth: data?.id, onClick: console.log(generalData) }}
          addParams={{
            dateQuery: "fechaDeFacturación",
            month: data?.id,
            value: label,
            ...params,
          }}
          ContentData={ContentData}
          actualData={{ ...generalData, fieldValue: label, numMonth: data?.id, urlApiMain: urlApiMain.replace(urlApi, `${urlApi}CompanyTable`).replace('Table ?', 'Table?') }}
        />
      </div>
    );
  }
  const monthList = [
    {
      label: "Enero",
      name: "1",
    },
    {
      label: "Febrero",
      name: "2",
    },
    {
      label: "Marzo",
      name: "3",
    },
    {
      label: "Abril",
      name: "4",
    },
    {
      label: "Mayo",
      name: "5",
    },
    {
      label: "Junio",
      name: "6",
    },
    {
      label: "Julio",
      name: "7",
    },
    {
      label: "Agosto",
      name: "8",
    },
    {
      label: "Septiembre",
      name: "9",
    },
    {
      label: "Octubre",
      name: "10",
    },
    {
      label: "Noviembre",
      name: "11",
    },
    {
      label: "Diciembre",
      name: "12",
    },
  ]

  function handleClickClient(label, _, urlApi, params) {
    openDialog(
      <div style={{ width: "80vw" }}>
        <ChartContainer
          title={`Mes: ${label.label}`}
          type="SubChart"
          urlApi={`${urlApi.substring(0, urlApi.length - 6)}Number`}
          addParams={{
            dateQuery: "fechaDeFacturación",
            month: label.id,
            ...params,
          }}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="flex gap-4 items-center mb-2">
        <h3>Gráfica de gerencia:</h3>
        <Select
          options={graficas}
          value={graficas.find((option) => option.value === chartType)}
          className="w-56"
          onChange={handleChartTypeChange}
        />
        {
          chartType !== "Encargados" && chartType !== "ProcEncargados" &&
          <>
            <h3> Gestión: {year}</h3>
            <Select
              options={gestiones}
              value={gestiones.find((option) => option.value === year)}
              onChange={handleYearChange}
            />
          </>
        }
      </div>
      {
        {
          Clientes: (
            <ChartContainer
              // onClick={handleClickCompanyMonth}
              title="Cantidad de tramites por cliente"
              urlApi={`/procedure/company/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              // isSmall={true}
              tableHeaders={[
                {
                  label: "Compañia",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          // Encargados: (
          //   <SimplePie
          //     id="1"
          //     title="Cantidad de Clientes por encargado"
          //     urlApi={`/procedure/inCharge/chart`}
          //     indexRef={["fullName", "companyCount", "percentage"]}
          //     tableHeaders={[
          //       {
          //         label: "Encargado",
          //         name: "fullName",
          //         aditionalClass: "bg-[#5f88c840]",
          //       },
          //       {
          //         label: "Cantidad",
          //         name: "companyCount",
          //         aditionalClass: "font-bold text-gray-500",
          //         isNumber: true,
          //         makeTotal: true
          //       },
          //       {
          //         label: "Porcentaje %",
          //         name: "percentage",
          //         aditionalClass: "font-bold text-gray-500",
          //         isNumber: true,
          //         makeTotalPercentage: true
          //       },
          //     ]}
          //   />
          // ),
          // ProcEncargados: (
          //   <SimplePie
          //     id="2"
          //     title="Cantidad de Trámites por encargado"
          //     urlApi={`/procedure/inChargeProcedures/chart`}
          //     indexRef={["fullName", "procedureCount", "percentage"]}
          //     showFilters={true}
          //     tableHeaders={[
          //       {
          //         label: "Encargado",
          //         name: "fullName",
          //         aditionalClass: "bg-[#5f88c840]",
          //       },
          //       {
          //         label: "Trámites",
          //         name: "procedureCount",
          //         aditionalClass: "font-bold text-gray-500",
          //         isNumber: true,
          //         makeTotal: true
          //       },
          //       {
          //         label: "Porcentaje %",
          //         name: "percentage",
          //         aditionalClass: "font-bold text-gray-500",
          //         isNumber: true,
          //         makeTotalPercentage: true
          //       },
          //     ]}
          //   />
          // ),
          Encargados: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por encargado"
              urlApi={`/Procedure/field/encargado/year/${year}/chart`}
              generalData={{ year, fieldname: 'encargado' }}
              isSmall
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_encargado/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por: ",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //     {
                  //       label: "Fecha de inicio",
                  //       name: "procFechaInicio",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList

                  },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Liquidador",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Liquidadores: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por liquidador"
              urlApi={`/Procedure/field/designacionDeLiquidador/year/${year}/chart`}
              generalData={{ year, fieldname: 'designacionDeLiquidador' }}
              isSmall
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_InCharge/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por: ",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //     {
                  //       label: "Fecha de inicio",
                  //       name: "procFechaInicio",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList

                  },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Liquidador",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Gestores: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por gestor"
              urlApi={`/Procedure/field/asignarGestor/year/${year}/chart`}
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_InCharge/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por:",
                  //   // defaultValue: "fechaDeFacturación",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList
                  },
                  // { type: "rangeDate" },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Gestor",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Intermediarios: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por intermediarios"
              urlApi={`/Procedure/field/intermediario/year/${year}/chart`}
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_InCharge/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por:",
                  //   // defaultValue: "fechaDeFacturación",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList
                  },
                  // { type: "rangeDate" },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Gestor",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Comisiones: (
            <ChartContainer
              onClick={handleClickClient}
              title="Monto de comisiones por mes"
              urlApi={`/Procedure/field/d-HonorariosProfesionales/year/${year}/chartAmount`}
              filters={filtersDefaultChartAmount}
              type="SimpleBar"
              addParams={{ dateQuery: "procFechaInicio" }}
              isSmall={true}
              defaultPie={true}
              amountTableHeaders={[
                {
                  label: "Mes",
                  name: "mes",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Monto",
                  name: "amount",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Cantidad",
                  name: "cantidad",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
              ]}
            />
          ),
          GastosOpe: (
            <ChartContainer
              onClick={handleClickClient}
              title="Gastos de operaciones por mes"
              urlApi={`/Procedure/field/c-GastosDeOperaciones/year/${year}/chartAmount`}
              filters={filtersDefaultChartAmount}
              type="SimpleBar"
              isSmall={true}
              addParams={{ dateQuery: "procFechaInicio" }}
              amountTableHeaders={[
                {
                  label: "Mes",
                  name: "mes",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Monto",
                  name: "amount",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Cantidad",
                  name: "cantidad",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
              ]}
            />
          ),
          "Problemas Del Despacho": (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por problemas del despacho"
              urlApi={`/Procedure/field/problemasDeDespacho/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Problema del Despacho",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          "Observaciones Aforo": (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por observaciones aforo"
              urlApi={`/Procedure/field/observaciones(Aforo)/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Observación Aforo",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Canales: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por canal"
              urlApi={`/Procedure/field/canal(Rojo,AmarilloOVerde)/year/${year}/chart`}
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_InCharge/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por:",
                  //   // defaultValue: "fechaDeFacturación",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList
                  },
                  // { type: "rangeDate" },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              isSmall={true}
              tableHeaders={[
                {
                  label: "Canal",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Mercadería: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por tipo de mercadería"
              urlApi={`/Procedure/field/tipoDeMercadería/year/${year}/chart`}
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_InCharge/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por:",
                  //   // defaultValue: "fechaDeFacturación",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList
                  },
                  // { type: "rangeDate" },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              isSmall={true}
              tableHeaders={[
                {
                  label: "tipo de mercadería",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          "Aduanas De Despachos": (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por aduana de despacho"
              urlApi={`/Procedure/field/a4AduanaDeDespacho/year/${year}/chart`}
              filters={[
                ...[
                  {
                    name: "procedureType",
                    url: "/procedureType",
                    default: "Todos los tramites",
                    valueOption: "id",
                    labelOption: "name",
                  },
                  // {
                  //   name: "liquidator",
                  //   url: "/Dropdown/rol_liquidator/options",
                  //   label: "Todos los liquidadores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "gestor",
                  //   url: "/Dropdown/rol_gestor/options",
                  //   label: "Todos los gestores",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "inCharge",
                  //   url: "/Dropdown/rol_InCharge/options",
                  //   label: "Todos los encargados",
                  //   valueOption: "id",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "prioridad",
                  //   url: "/Dropdown/prioridad/options",
                  //   label: "Prioridad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "complejidad",
                  //   url: "/Dropdown/ComplejidadDelDespacho/options",
                  //   label: "Complejidad",
                  //   valueOption: "name",
                  //   labelOption: "name",
                  // },
                  // {
                  //   name: "dateQuery",
                  //   label: "Filtrar fecha por:",
                  //   // defaultValue: "fechaDeFacturación",
                  //   options: [
                  //     {
                  //       label: "Fecha de facturación",
                  //       name: "fechaDeFacturación",
                  //     },
                  //     {
                  //       label: "Fecha aceptación",
                  //       name: "a2FechaDeAceptación",
                  //     },
                  //   ],
                  // },
                  {
                    name: "months",
                    label: "Todos los meses",
                    options: monthList
                  },
                  // { type: "rangeDate" },
                ],
              ]}
              addParams={{ dateQuery: "procFechaInicio" }}
              isSmall={true}
              tableHeaders={[
                {
                  label: "Compañia",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          "Examen Previo": (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por examen previo"
              urlApi={`/Procedure/field/examenPrevioRealizado/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Exámen prévio",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          Multas: (
            <ChartContainer
              onClick={handleClickClient}
              title="Monto de multas por mes"
              urlApi={`/Procedure/field/montoDeMultaPorContravencion/year/${year}/chartAmount`}
              filters={filtersDefaultChartAmount}
              type="SimpleBar"
              isSmall={true}
              addParams={{ dateQuery: "procFechaInicio" }}
              amountTableHeaders={[
                {
                  label: "Mes",
                  name: "mes",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Monto",
                  name: "amount",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Cantidad",
                  name: "cantidad",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
              ]}
            />
          ),
          Reintegros: (
            <ChartContainer
              onClick={handleClickClient}
              title="Monto de reintegros por mes"
              urlApi={`/Procedure/field/montoDeReintregro/year/${year}/chartAmount`}
              filters={filtersDefaultChartAmount}
              type="SimpleBar"
              isSmall={true}
              addParams={{ dateQuery: "procFechaInicio" }}
              amountTableHeaders={[
                {
                  label: "Mes",
                  name: "mes",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Monto",
                  name: "amount",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Cantidad",
                  name: "cantidad",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
              ]}
            />
          ),
          "Multa Fiscalización": (
            <ChartContainer
              onClick={handleClickClient}
              title="Monto de multa fiscalización por mes"
              urlApi={`/Procedure/field/multaPorContravencion(ControlDiferido)/year/${year}/chartAmount`}
              filters={filtersDefaultChartAmount}
              type="SimpleBar"
              isSmall={true}
              addParams={{ dateQuery: "procFechaInicio" }}
              amountTableHeaders={[
                {
                  label: "Mes",
                  name: "mes",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Monto",
                  name: "amount",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Cantidad",
                  name: "cantidad",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
              ]}
            />
          ),
          "Reintegro Fiscalización": (
            <ChartContainer
              onClick={handleClickClient}
              title="Monto reintegro fiscalización por mes"
              urlApi={`/Procedure/field/montoDeReintegro-ControlDiferido(Bs)/year/${year}/chartAmount`}
              filters={filtersDefaultChartAmount}
              type="SimpleBar"
              isSmall={true}
              addParams={{ dateQuery: "procFechaInicio" }}
              amountTableHeaders={[
                {
                  label: "Mes",
                  name: "mes",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Monto",
                  name: "amount",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Cantidad",
                  name: "cantidad",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
              ]}
            />
          ),
          "Gestoria Lista De Observaciones": (
            <ChartContainer
              onClick={handleClickMonth}
              title="Gestoria Lista De Observaciones"
              urlApi={`/Procedure/field/gestoriaListaDeObservaciones(ProblemasEnElDespachoConcluido)/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Gestoria Lista De Observaciones",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          "Contabilidad Lista De Observaciones": (
            <ChartContainer
              onClick={handleClickMonth}
              title="Contabilidad Lista De Observaciones"
              urlApi={`/Procedure/field/contabilidadListaDeObservaciones(ProblemasEnElDespachoConcluido)/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              tableHeaders={[
                {
                  label: "Contabilidad Lista De Observaciones",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
          OrigenDelEmbarque: (
            <ChartContainer
              onClick={handleClickMonth}
              title="Cantidad de tramites por canal"
              urlApi={`/Procedure/field/origenDelEmbarque/year/${year}/chart`}
              filters={filtersDefaultChart}
              addParams={{ dateQuery: "procFechaInicio" }}
              isSmall={true}
              tableHeaders={[
                {
                  label: "Canal",
                  name: "option",
                  aditionalClass: "bg-[#5f88c840]",
                },
                {
                  label: "Cantidad",
                  name: "total",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotal: true,
                },
                {
                  label: "Porcentaje %",
                  name: "percentage",
                  aditionalClass: "font-bold text-gray-500",
                  isNumber: true,
                  makeTotalPercentage: true
                },
              ]}
            />
          ),
        }[chartType]
      }
    </div >
  );
};

export default Management;
